export default "__VITE_ASSET__DOgaUCjC__"